import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormControl
} from "@mui/material";
import PhoneInput from "react-phone-input-2";
import { makeStyles } from "@mui/styles";
import Layout from "../../components/Wrappers/Layout";
import {
	Card,
	Alert,
	Row,
	Col,
	CardTitle,
	CardHeader,
	FormGroup
} from "reactstrap";
// import { AiOutlineSearch } from "react-icons/ai";
// import { AiOutlineUserAdd } from "react-icons/ai";
// import { AiOutlineFileAdd } from "react-icons/ai";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import { Route, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import BackButton from "../../components/BackButton/BackButton";
import { countries } from "../../utils/countriesDropdown";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import CustomButton from "../../components/CustomButton/CustomButton";
import CommonLogout from "../../components/CommonLogout/CommonLogout";
import { createOrUpdateWalletOwner } from "../../redux/actions/createOrUpdateWalletOwnerAction";
import { getThemeList } from "../../redux/actions/getThemeListAction";
// import { getWalletOwnerIdAndNameList } from '../../redux/actions/getWalletOwnerIdAndNameListAction';
import { getWalletOwnerSettingDetails } from "../../redux/actions/getWalletOwnerSettingDetailsAction";
// import { ContactsOutlined } from "@mui/icons-material";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";
import val from "../../getThemeDetails";
const AdminWalletOwnerView = () => {
	const dispatch = useDispatch();
	const navigate = useHistory();

	const location = useLocation();
	// const WalletOwnerId = location.search.split("?userId=")[1];
	const WalletOwnerId = location.search.split("?userId=")[1];
	const [getWalletOwnerStatus, setGetWalletOwnerStatus] = useState(false);
	const [getWalletOwnerResArray, setGetWalletOwnerResArray] = useState([]);
	console.log(WalletOwnerId);
	const name = location.state.name;
	console.log(name);
	// console.log(WalletOwnerId);

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const getWalletOwnerSettingDetail = useSelector(
		({ getWalletOwnerSettingDetails }) => getWalletOwnerSettingDetails
	);

	console.log("getWalletOwnerSettingDetails" + getWalletOwnerSettingDetails);

	console.log("getWalletOwnerResArray", getWalletOwnerResArray);

	const getWalletOwnerIdAndNameStatusFunc = () => {
		setGetWalletOwnerStatus(true);
		const getWalletOwnerIdAndNameListReq = {
			loginDetails: {
				// adminId: "2"
				adminId: val.adminIDS

			},
			ownerMasterRequestVO: {
				ownerID: WalletOwnerId
			}
		};
		return dispatch(
			getWalletOwnerSettingDetails(
				getWalletOwnerIdAndNameListReq,
				regenerateTokenRes.data.AuthToken
			)
		);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getWalletOwnerIdAndNameStatusFunc();
		}
	}, [regenerateTokenRes.data.status, WalletOwnerId]);

	const [user, setUser] = useState({
		ownerID: "",
		walletOwnerName: "",
		SMTPHost: "",
		EmailFrom: "",
		EmailSubjectOnReg: "",
		SmsContentOnReg: "",
		SmsFrom: "",
		SmsToken: "",
		SmsPassword: "",
		SmsProvider: "",
		SmsContentOnOtp: "",
		EmailContentOnReg: "",
		SMTPPort: "",
		SmsSecret: "",
		SMTPPassword: "",
		SmsUrl: "",
		SmsUser: "",
		SMTPUserName: "",
		EmailContentOnOtp: ""
	});

	const {
		ownerID,
		walletOwnerName,
		SMTPHost,
		EmailFrom,
		EmailSubjectOnReg,
		SmsContentOnReg,
		SmsFrom,
		SmsToken,
		SmsPassword,
		SmsProvider,
		SmsContentOnOtp,
		EmailContentOnReg,
		SMTPPort,
		SmsSecret,
		SMTPPassword,
		SmsUrl,
		SmsUser,
		SMTPUserName,
		EmailContentOnOtp
	} = user;

	const getWalletOwnerListResFunc = () => {
		if (getWalletOwnerStatus) {
			if (getWalletOwnerSettingDetail.data.status == "success") {
				setGetWalletOwnerResArray(
					getWalletOwnerSettingDetail.data.walletOwnerSettings
				);
			}
			if (getWalletOwnerSettingDetail.data.status == "failed") {
				setGetWalletOwnerResArray(getWalletOwnerSettingDetail.data);
			}
			if (
				getWalletOwnerSettingDetail.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				getWalletOwnerSettingDetail.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}
	};

	useEffect(() => {
		if (getWalletOwnerSettingDetail.data.status == "success") {
			getWalletOwnerListResFunc();
		}
	}, [getWalletOwnerSettingDetail]);

	useEffect(() => {
		if (getWalletOwnerSettingDetail.data.walletOwnerSettings !== null) {
			setUser({
				SMTPHost: getWalletOwnerResArray.smtpHost,
				EmailFrom: getWalletOwnerResArray.emailFrom,
				EmailSubjectOnReg: getWalletOwnerResArray.isEMAILSubjectOnReg,
				SmsContentOnReg: getWalletOwnerResArray.isSMSContentOnReg,
				SmsFrom: getWalletOwnerResArray.isSMSFrom,
				SmsToken: getWalletOwnerResArray.smsToken,
				SmsPassword: getWalletOwnerResArray.isSMSPassword,
				SmsProvider: getWalletOwnerResArray.smsProvider,
				SmsContentOnOtp: getWalletOwnerResArray.isSMSContentOnOtp,
				EmailContentOnReg: getWalletOwnerResArray.isEMAILContentOnReg,
				SMTPPort: getWalletOwnerResArray.smtpPort,
				SmsSecret: getWalletOwnerResArray.smsSecret,
				SMTPPassword: getWalletOwnerResArray.smtpPass,
				SmsUrl: getWalletOwnerResArray.isSMSUrl,
				SmsUser: getWalletOwnerResArray.isSMSUser,
				SMTPUserName: getWalletOwnerResArray.smtpUser,
				EmailContentOnOtp: getWalletOwnerResArray.isEMAILContentOnOtp
			});
		} else {
			setUser({
				ownerID: "",
				SMTPHost: "",
				EmailFrom: "",
				EmailSubjectOnReg: "",
				SmsContentOnReg: "",
				SmsFrom: "",
				SmsToken: "",
				SmsPassword: "",
				SmsContentOnOtp: "",
				EmailContentOnReg: "",
				SMTPPort: "",
				SmsSecret: "",
				SMTPPassword: "",
				SmsUrl: "",
				SmsUser: "",
				SMTPUserName: "",
				EmailContentOnOtp: ""
			});
		}
	}, [getWalletOwnerResArray]);

	const handleClose = () => {
		if (getWalletOwnerSettingDetail.data.status == "success") {
			navigate.push({
				pathname: `/index/wallet-owner-settings`
			});
			// getWalletOwnerIdAndNameListRequest()
		}
	};

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					<Grid container>
						<Grid item lg={2} md={2}></Grid>
						<Grid item lg={10} md={10}></Grid>
					</Grid>
					<br />
					<Grid container>
						<Grid item xs={12} lg={12} md={12} sm={12}>
							<h6 align="center" className="text-center themeText">
								{" "}
								Owner Settings
							</h6>
						</Grid>
					</Grid>

					<Grid container style={{ padding: "30px     10px" }}>
						<Grid item xs={12} md={2} lg={2}></Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								label="Owner ID"
								type="text"
								fullWidth
								variant="standard"
								value={WalletOwnerId}
								name="walletOwnerID"
								disabled
								setData
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							></TextField>
						</Grid>
						<Grid item xs={12} md={2} lg={2}></Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								label="Owner Name"
								type="text"
								variant="standard"

								fullWidth
								name="walletOwnerName"
								value={name}
								disabled
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>
						</Grid>

						<Grid container style={{ padding: "10px" }}>
							<Grid
								item
								xs={12}
								lg={12}
								md={12}
								sm={12}
								className="tableHeaderColor"
								style={{
									marginTop: "36px",
									padding: "10px",
									// backgroundColor: "#00b9f5",
									// color: "#fff"
								}}
							>
								<h6 align="center" className="">
									{" "}
									SMS Configuration
								</h6>
							</Grid>
							<Grid item xs={12} md={2} lg={2}></Grid>
							<Grid item xs={12} md={8} lg={8}>
								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												variant="standard"

												autoFocus={true}
												label="Sms Provider"
												fullWidth={true}
												name="SmsProvider"
												value={SmsProvider}
												disabled
											></TextField>
										</FormControl>
									</FormGroup>
								</div>
								<div style={{ marginTop: "1.5rem" }}>
									<TextField
										size="small"
										variant="standard"

										color="primary"
										autoFocus={true}
										label="Sms URL"
										fullWidth={true}
										name="SmsUrl"
										value={SmsUrl}
										disabled
									/>
								</div>

								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												variant="standard"

												color="primary"
												autoFocus={true}
												label="Sms Token"
												fullWidth={true}
												name="SmsToken"
												value={SmsToken}
												disabled
											/>
										</FormControl>
									</FormGroup>
								</div>
								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												autoFocus={true}
												label="Sms Secret"
												variant="standard"
												fullWidth={true}
												name="SmsSecret"
												value={SmsSecret}
												disabled
											/>
										</FormControl>
									</FormGroup>
								</div>
								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												variant="standard"

												autoFocus={true}
												label="Sms User"
												fullWidth={true}
												name="SmsUser"
												value={SmsUser}
												disabled
											/>
										</FormControl>
									</FormGroup>
								</div>
								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<TextField
										size="small"
										color="primary"
										variant="standard"

										autoFocus={true}
										type="string"
										label="Sms Password"
										fullWidth={true}
										name="SmsPassword"
										value={SmsPassword}
										disabled
									></TextField>
								</div>

								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												variant="standard"

												autoFocus={true}
												label="Sms From"
												fullWidth={true}
												name="SmsFrom"
												value={SmsFrom}
												disabled
											/>
										</FormControl>
									</FormGroup>
								</div>

								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												variant="standard"

												autoFocus={true}
												label="Sms Content On Reg"
												fullWidth={true}
												name="SmsContentOnReg"
												value={SmsContentOnReg}
												disabled
											/>
										</FormControl>
									</FormGroup>
								</div>

								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												variant="standard"

												autoFocus={true}
												label="Sms Content On Otp"
												fullWidth={true}
												name="SmsContentOnOtp"
												value={SmsContentOnOtp}
												disabled
											/>
										</FormControl>
									</FormGroup>
								</div>
							</Grid>

							<Grid
								item
								xs={12}
								lg={12}
								md={12}
								sm={12}
								className="tableHeaderColor"
								style={{
									marginTop: "36px",
									padding: "10px",
									// backgroundColor: "#00b9f5",
									// color: "#fff"
								}}
							>
								<h6 align="center" className="text-center tableHeaderColor" >
									{" "}
									Email Configuration
								</h6>
							</Grid>
							<Grid item xs={12} md={2} lg={2}></Grid>
							<Grid item xs={12} md={8} lg={8}>
								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												autoFocus={true}
												variant="standard"

												label="Email Content On Reg"
												fullWidth={true}
												name="EmailContentOnReg"
												value={EmailContentOnReg}
												disabled
											/>
										</FormControl>
									</FormGroup>
								</div>
								<div style={{ marginTop: "1.5rem" }}>
									<TextField
										size="small"
										color="primary"
										variant="standard"

										autoFocus={true}
										label="Email Subject On Reg"
										fullWidth={true}
										name="EmailSubjectOnReg"
										value={EmailSubjectOnReg}
										disabled
									/>
								</div>

								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												autoFocus={true}
												variant="standard"

												label="Email Content On Otp"
												fullWidth={true}
												name="EmailContentOnOtp"
												value={EmailContentOnOtp}
												disabled
											/>
										</FormControl>
									</FormGroup>
								</div>
								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												autoFocus={true}
												label="SMTP Host"
												variant="standard"
												fullWidth={true}
												name="SMTPHost"
												value={SMTPHost}
												disabled
											/>
										</FormControl>
									</FormGroup>
								</div>
								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												variant="standard"

												autoFocus={true}
												label="SMTP Port"
												fullWidth={true}
												name="SMTPPort"
												value={SMTPPort}
												disabled
											/>
										</FormControl>
									</FormGroup>
								</div>
								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<TextField
										size="small"
										color="primary"
										autoFocus={true}
										variant="standard"

										type="string"
										label="Email From"
										fullWidth={true}
										name="EmailFrom"
										value={EmailFrom}
										disabled
									></TextField>
								</div>

								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												autoFocus={true}
												label="SMTP User Name"
												variant="standard"

												fullWidth={true}
												name="SMTPUserName"
												value={SMTPUserName}
												disabled
											/>
										</FormControl>
									</FormGroup>
								</div>

								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												autoFocus={true}
												label="SMTP Password"
												variant="standard"

												fullWidth={true}
												name="SMTPPassword"
												value={SMTPPassword}
												disabled
											/>
										</FormControl>
									</FormGroup>
								</div>
								<div style={{ marginTop: "1.5rem", float: "right" }}>
									<CustomButton

										variant="contained"
										onClick={handleClose}
									>
										Cancel
									</CustomButton>
									{/* <Button
										style={{
											backgroundColor: "#00b9f5",
											color: "#fff"
										}}
										variant="contained"
										onClick={handleClose}
									>
										Cancel
									</Button> */}
								</div>
							</Grid>
						</Grid>
					</Grid>
				</Card>
			</Layout>
		</>
	);
};

export default AdminWalletOwnerView;
